import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
  PLUGINS: { TRACKCHANGE_EDITING },
} = CkeditorConstants;

export default class TrackChangesLabelEditing extends Plugin {
  init() {
    const editor = this.editor;
    const trackChangesEditing = editor.plugins.get(TRACKCHANGE_EDITING);

    trackChangesEditing.descriptionFactory.registerDescriptionCallback(
      (suggestion) => {
        const { type } = suggestion;
        const suggestionItems = [...suggestion.getItems()];
        if (
          (suggestionItems.length &&
            suggestionItems[0].name !== "caption" &&
            suggestionItems[0].parent?.name !== "table") ||
          !suggestionItems.length
        ) {
          return;
        }

        if (type === "insertion") {
          return {
            type: type,
            content: `*Insert:* caption`,
          };
        }
      }
    );
  }
}
